import { j as l } from "../../../../../node_modules/react/jsx-runtime.js";
import { memo as v, useMemo as N } from "react";
import { clsx as c } from "../../../../../node_modules/clsx/dist/clsx.m.js";
import { Typography as x } from "../../../../atoms/Typography/Typography.js";
import o from "../../Table.module.scss.js";
const D = ({ text: t, subText: e }) => /* @__PURE__ */ l.jsxs("div", { className: "flex flex-col w-fit h-fit", children: [
  t && /* @__PURE__ */ l.jsx(
    x,
    {
      text: t,
      variant: "interface/default/sm",
      textColor: e ? "color/fg/light" : "color/fg/lighter"
    }
  ),
  e && /* @__PURE__ */ l.jsx(
    x,
    {
      text: e,
      variant: "body-new/regular",
      textColor: "color/fg/lighter"
    }
  )
] }), P = ({
  id: t,
  text: e,
  subText: r,
  alignment: s,
  disabled: n,
  custom: i,
  width: f,
  pinnedFirst: a,
  pinnedLast: m,
  rowDensity: u = "auto",
  selectable: y,
  isSelected: p,
  rowMinHeight: g,
  minWidth: C,
  children: h,
  ...d
}) => {
  var j;
  const b = document.body.getAttribute("dir") === "rtl", S = N(
    () => ({
      relaxed: "!min-h-[60px]",
      regular: "!min-h-600",
      condensed: "!min-h-500",
      auto: "!h-fit"
    })[u],
    [u]
  );
  return /* @__PURE__ */ l.jsx(
    "td",
    {
      className: c(o.tableDataCell, {
        [o.tablePinnedFirstColumn]: a && !"select-col".includes(String(t)),
        [o.tablePinnedFirstSelectableColumn]: y && a,
        [o.tablePinnedLastColumn]: m && !"select-col".includes(String(t)),
        "!z-[39]": (a || m) && !"select-col".includes(String(t)),
        [`sticky !z-[39] left-0 right-auto ${b ? "!right-0 !left-auto" : ""}`]: t == null ? void 0 : t.toString().includes("select-col"),
        "cursor-not-allowed": n,
        "!bg-color-bg-brand-lightest-default": p
      }),
      "aria-disabled": n,
      "data-testid": `data-cell-${t}`,
      style: {
        width: f,
        minWidth: C,
        maxWidth: f
      },
      ...d,
      children: /* @__PURE__ */ l.jsx(
        "div",
        {
          className: c(
            S,
            { "content-center": g },
            ((t == null ? void 0 : t.toString().includes("custom_actions")) || ((j = d.actions) == null ? void 0 : j.length)) && o.tableActionsTd
          ),
          style: { minHeight: g },
          children: !!(e || r || i || h) && /* @__PURE__ */ l.jsx(
            "div",
            {
              className: c("flex justify-start items-center h-full w-full py-050", {
                "!justify-start": s === "left",
                "!justify-center": s === "center",
                "!justify-end": s === "right"
              }),
              children: h || (e || r ? /* @__PURE__ */ l.jsx(
                D,
                {
                  text: e,
                  subText: r
                }
              ) : i)
            }
          )
        }
      )
    }
  );
}, W = v(P);
export {
  W as default
};
//# sourceMappingURL=DataCell.js.map
